import { DatePipe } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageChannelService, BnLoadingService, EntityPagedResult, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_AGENTE_CONSULTA, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Cobranca, TIPO_COBRANCA } from 'src/app/model/cobranca.model';
import { EstadoCobranca } from 'src/app/model/dominio-cobranca.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { CobrancaService } from './cobranca.service';


@Component({
    selector: 'app-cobranca-pesquisa',
    templateUrl: './cobranca-pesquisa.component.html',
    standalone: false
})
export class CobrancaPesquisaComponent implements OnInit {

  private podeEscolherAgente: boolean = false;
  public ehAgenteFinanceiro: boolean = false;

  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private tiposCobranca = TIPO_COBRANCA;
  private estados: EstadoCobranca[] = [];
  
  cnpjUsuario: string;

  public pesquisado: boolean; // usado no html
  public esconderPesquisa: boolean;
  public cobrancas: Cobranca[];


  // modelo do formulario
  private idCobranca:number;
  private codigoCobranca: number;
  private agenteFinanceiro: AgenteFinanceiro;
  private codigoTipoCobranca: String;
  private estado: EstadoCobranca;
  private dataEmissaoDaFichaInicial: Date;
  private dataVencimentoDaFichaInicial: Date;
  private dataLimiteParaPagamentoDaFichaInicial: Date;
  private dataEmissaoDaFichaFinal: Date;
  private dataVencimentoDaFichaFinal: Date;
  private dataLimiteParaPagamentoDaFichaFinal: Date;

  private atributosPaginacaoComponenteListagem: EntityPagedResult<Cobranca>;
  private opcoesPaginacao: number[];

  private pesquisaForm: UntypedFormGroup;
  private valoresPesquisaForm: any;

  private totalObjetosRetornados: number;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private service: CobrancaService,
    private datePipe: DatePipe,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private activatedRoute: ActivatedRoute,
    private messageService: MessageChannelService) {
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar(false,true);
  }

  ngOnInit() {
    this.opcoesPaginacao = [10, 15, 20];
    this.esconderPesquisa = true;
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((permissao: any) => {
      this.podeEscolherAgente = permissao && permissao[ROLE_GESTOR_CONSULTA];
      this.ehAgenteFinanceiro = permissao && permissao[ROLE_AGENTE_CONSULTA];
    });
    
    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario && usuario.cnpj;
    });

    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver
    this.estados = this.activatedRoute.snapshot.data['dominios'].estadosCobranca;
    this.construirFormulario();
  }

  private construirFormulario() {
    this.valoresPesquisaForm = JSON.parse(sessionStorage.getItem('valoresPesquisaCobrancaForm'));

    this.pesquisaForm = this.formBuilder.group({
        idCobranca: [this.valoresPesquisaForm ? this.valoresPesquisaForm.id : '', [Validators.pattern(/^[0-9]+$/), Validators.minLength(1)]],
        codigoCobranca: [this.valoresPesquisaForm ? this.valoresPesquisaForm.codigoCobranca : '',[Validators.pattern(/^[0-9]+$/), Validators.minLength(1)]],
        agenteFinanceiro: [this.valoresPesquisaForm ? this.valoresPesquisaForm.agenteFinanceiro : ''],
        tipoCobranca: [this.valoresPesquisaForm ? this.valoresPesquisaForm.tipoCobranca : ''],
        estado: [this.valoresPesquisaForm ? this.valoresPesquisaForm.estado : ''],
        dataEmissaoDaFichaInicial: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataEmissaoDaFichaInicial : ''],
        dataVencimentoDaFichaInicial: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataVencimentoDaFichaInicial : ''],
        dataLimiteParaPagamentoDaFichaInicial: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataLimiteParaPagamentoDaFichaInicial : ''],
        dataEmissaoDaFichaFinal: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataEmissaoDaFichaFinal : ''],
        dataVencimentoDaFichaFinal: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataVencimentoDaFichaFinal : ''],
        dataLimiteParaPagamentoDaFichaFinal: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataLimiteParaPagamentoDaFichaFinal : ''],
    });

    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.valoresPesquisaForm = novosValores;
      sessionStorage.setItem('valoresPesquisaCobrancaForm', JSON.stringify(this.valoresPesquisaForm));
    });
  }

  mudancaPagina(novaPagina: EntityPagedResult<Cobranca>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  buscar(paginaVazia, voltarPagina1) {
    this.loadingService.bloqueiaTela();
    this.esconderPesquisa = true;
    const params: any = {};

    this.idCobranca = this.pesquisaForm.get('idCobranca').value;
    this.codigoCobranca = this.pesquisaForm.get('codigoCobranca').value;
    this.dataEmissaoDaFichaInicial = this.pesquisaForm.get('dataEmissaoDaFichaInicial').value;
    this.dataEmissaoDaFichaFinal = this.pesquisaForm.get('dataEmissaoDaFichaFinal').value;
    this.dataVencimentoDaFichaInicial = this.pesquisaForm.get('dataVencimentoDaFichaInicial').value;
    this.dataVencimentoDaFichaFinal = this.pesquisaForm.get('dataVencimentoDaFichaFinal').value;
    this.dataLimiteParaPagamentoDaFichaInicial = this.pesquisaForm.get('dataLimiteParaPagamentoDaFichaInicial').value;
    this.dataLimiteParaPagamentoDaFichaFinal = this.pesquisaForm.get('dataLimiteParaPagamentoDaFichaFinal').value;

    const nomeAgenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;
    
    if (this.podeEscolherAgente) {
      this.agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.nome === nomeAgenteFinanceiro)[0];
    }
    else {
      this.agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
    }

    const nomeEstado = this.pesquisaForm.get('estado').value;

    this.estado = this.estados.filter(estado => estado.nome === nomeEstado)[0];

    const nomeTipoCobranca = this.pesquisaForm.get('tipoCobranca').value;
    this.codigoTipoCobranca = nomeTipoCobranca ? TIPO_COBRANCA.filter(tipo => tipo.labelCompleto === nomeTipoCobranca)[0].codigo : undefined;

    if (this.idCobranca) {
      params.id = this.idCobranca;
    }

    if (this.codigoCobranca) {
      params.codigoCobranca = this.codigoCobranca;
    }
    
    if (this.agenteFinanceiro) {
        params.cnpjAgenteFinanceiro = this.agenteFinanceiro.cnpj;
    }

    if (this.dataEmissaoDaFichaInicial) {
      params.dataEmissaoDaFichaInicial = this.datePipe.transform(this.dataEmissaoDaFichaInicial, 'yyyyMMdd');
    }

    if (this.dataEmissaoDaFichaFinal) {
      params.dataEmissaoDaFichaFinal = this.datePipe.transform(this.dataEmissaoDaFichaFinal, 'yyyyMMdd');
    }

    if (this.dataVencimentoDaFichaInicial) {
      params.dataVencimentoDaFichaInicial = this.datePipe.transform(this.dataVencimentoDaFichaInicial, 'yyyyMMdd');
    }

    if (this.dataVencimentoDaFichaFinal) {
      params.dataVencimentoDaFichaFinal = this.datePipe.transform(this.dataVencimentoDaFichaFinal, 'yyyyMMdd');
    }

    if (this.dataLimiteParaPagamentoDaFichaInicial) {
      params.dataLimiteParaPagamentoDaFichaInicial = this.datePipe.transform(this.dataLimiteParaPagamentoDaFichaInicial, 'yyyyMMdd');
    }

    if (this.dataLimiteParaPagamentoDaFichaFinal) {
      params.dataLimiteParaPagamentoDaFichaFinal = this.datePipe.transform(this.dataLimiteParaPagamentoDaFichaFinal, 'yyyyMMdd');
    }

    if (this.estado) {
      params.ideEstado = this.estado.id;
    }

    if (this.codigoTipoCobranca) {
      params.tipoCobranca = this.codigoTipoCobranca;
    }
    
    if(voltarPagina1){
      this.atributosPaginacaoComponenteListagem.page = 1;
    }
    paginaVazia = Utils.verificaPaginaVazia(this.cobrancas, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }

    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

    
    this.service.getCobrancas(params)
      .subscribe(response => {
        this.cobrancas = response ? response.resultados : undefined;
        this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
        this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
        this.pesquisado = true;
        this.esconderPesquisa = false;
        this.loadingService.liberaTela();
         
        paginaVazia = Utils.verificaPaginaVazia(this.cobrancas, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true);
        }
      });
  }

  gerarRelatorioRepasseECG() {
    this.service.getRelatorioCobrancaECG().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Relatório gerado com sucesso'
      });
    });
  }

  compararPorId(item1: string, item2: string): boolean {

    if (item1 && item2) {
      return item1 === item2;
    }
    if (!item1 && !item2) {
      return true;
    }
    return false;
  }

  limpar() {
    this.pesquisado = undefined;

    this.pesquisaForm.reset();
    this.pesquisaForm.updateValueAndValidity();
  }
}